import { useEffect, useState } from 'react';

const DEBOUNCE_MS = 500;

const useDebounce = (value: string, delay = DEBOUNCE_MS) => {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delay);

    return () => clearTimeout(id);
  }, [value, delay]);

  return debounced;
};

export default useDebounce;
